import { ContentService } from '@blk/cwp-ng-framework';
import { AbstractRenderer, BusinessComponent, BusinessComponentOptions, StaticParagraphComponent } from '@blk/simba';
import { ComponentData, TabData, TabUtil } from '@ddt-web/data-service';
import { ReportType } from '@ddt-web/pdf-utils';
import * as get from 'lodash/get';

import { DisclosureComponent } from '../../disclaimers/disclosure-component';
import { HeadingComponent, HeadingLevel } from '../../heading/heading-component';
import { ReducedSpacingConfig } from '../../helpers/config';
import { FundPerformancePanelsHelper } from '../../helpers/fund-performance/fund-performance-panels-helper';

export class StandardizedPerformanceNavComponent extends BusinessComponent {
	private stdPerfNavTab: TabData;
	private reducedSpacingConfig = ReducedSpacingConfig.standardizedPerformanceNav;

	constructor(
		name: string,
		public dataComponentId: string,
		private mode?: ReportType,
		private showTitle: boolean = false,
		private shouldReduceSpacing: boolean = false,
		visible: boolean = true
	) {
		super(name, 'BusinessComponent', BusinessComponentOptions.merge({ visible: visible, componentId: dataComponentId }));
	}

	public isComponentDataVisible(componentData: ComponentData): boolean {
		const isComponentDataSuccessful = componentData && componentData.success;
		this.stdPerfNavTab = isComponentDataSuccessful && get(componentData, 'tabs[1]');

		return TabUtil.isTabValid(this.stdPerfNavTab);
	}

	public buildComponent(componentData: ComponentData, contentSvc: ContentService): AbstractRenderer<SVGGElement>[] {
		const panels: AbstractRenderer<SVGGElement>[] = [];
		const paragraphConstraints = this.shouldReduceSpacing ? this.reducedSpacingConfig.staticParagraph : { paddingBottom: 20 };
		const disclosureConstraints = this.shouldReduceSpacing ? this.reducedSpacingConfig.disclosure : { paddingTop: 15, paddingBottom: 20 };
		if (this.isComponentDataVisible(componentData)) {

			if (this.showTitle) {
				panels.push(
					...[
						new HeadingComponent('PDF_FUND_PERF_H2', 'Fund Performance', HeadingLevel.H2),
						new StaticParagraphComponent('PDF_FUND_PERF_DISCLAIMER', 'Applicable to Mutual funds and ETFs only', {}, paragraphConstraints)
					]
				);
			}

			panels.push(
				...[
					new HeadingComponent('PDF_QUART_RET_NAV_H3', 'QUARTERLY RETURNS - NAV(%)', HeadingLevel.H3),
					...FundPerformancePanelsHelper.getAsOfDatePanel(this.stdPerfNavTab, {}, this.shouldReduceSpacing),
					...FundPerformancePanelsHelper.getFundPerformancePanels(this.stdPerfNavTab, contentSvc, {}, this.mode, this.shouldReduceSpacing),
					new DisclosureComponent('PDF_QUART_RET_NAV_DISCLAIMER', '* Annualized', {}, disclosureConstraints)
				]
			);
		}
		return panels;
	}
}
